class GalleryMobile3dids extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.dotsContainer = this.querySelector('[data-dots]');
    if (!this.track || !this.dotsContainer) return;

    this.slides = [...this.track.children];
    this.dots = this.slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'gallery-mobile-3dids__dot';
      dot.setAttribute('aria-label', String(index + 1));
      dot.addEventListener('click', () => this.track.scrollTo({ left: this.slides[index].offsetLeft, behavior: 'smooth' }));
      this.dotsContainer.appendChild(dot);
      return dot;
    });

    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.update();
  }

  update() {
    const index = Math.round(this.track.scrollLeft / (this.slides[0]?.offsetWidth || 1));
    this.dots.forEach((dot, dotIndex) => dot.toggleAttribute('data-active', dotIndex === index));
  }
}

if (!customElements.get('gallery-mobile-3dids')) {
  customElements.define('gallery-mobile-3dids', GalleryMobile3dids);
}
